import HistoryElement from "./HistoryElement";
import { debounce } from "../helpers";
import { gsap } from "gsap";
import { hasClass, getViewport } from "../helpers";


// TODO: SORTING STOPS DRAWER ANIMATION
/**
 * Filter form management
 * @typedef {Object} CustomElement~FilterForm
 */
class FilterForm extends HistoryElement {

	constructor(){

		super();

		this.gridId = this.dataset.section;
		this.grid = document.querySelector(`[data-id="${this.gridId}"]`);
		this.form = this.closest("form") || this.querySelector("form");
		this.filterWrapper = this.querySelector(".filters");
		this.open = this.dataset.open || false;
		this.sort = this.querySelector("select[name='sort_by']") || this.querySelectorAll("input[name='sort_by']");
		this.sortTrigger = document.querySelector("[name='sort_by_trigger']");
		this.matchMedia = gsap.matchMedia();

		/** --- Filter drawer hide/show --- */
		this.filterToggle = document.querySelector("toggle-filters");

		if(this.filterToggle) {

			this.setTimeline();

			let filterText = this.filterToggle.querySelector("button span");

			this.filterToggle.dataset.open = this.open;
			// this.filterToggle.addEventListener("click", this.toggleOpen.bind(this));

			if(getViewport().width <= 768) {

				this.open = false;

				filterText.textContent = filterText.textContent.replace("Hide", "Show");
			}

			if(this.open === "true" || this.open === true) {

				filterText.textContent = filterText.textContent.replace("Show", "Hide");

				this.timeline.progress(1).pause();
			}
		}

		/** --- Range Price --- */
		this.rangePrice = document.querySelector("range-price");

		if(this.rangePrice) {

			customElements.define("range-price", FilterRange);
		}

		/** --- Initial params --- */
		this.initialParams = window.location.search.slice(1);
		this.previousParams = this.initialParams;

		/** --- Prep cache --- */
		this.filterCache = [];

		/** --- Bind events --- */
		this.bindEvents();
	}

	/**
	 * Our animation timeline
	 */
	setTimeline() {

		this.baseWidth = this.clientWidth;
		this.timeline = gsap.timeline({
			paused: true
		});

		/** Desktop Animation */
		this.matchMedia.add("(min-width: 769px)", () => {

			this.style.overflow = "hidden";
			this.timeline.fromTo(this, {
				minWidth: 0,
				width: 0
			}, {
				minWidth: this.baseWidth,
				width: this.baseWidth,
				duration: 0.3,
				ease: "Power2.inOut"
			});
		});

		/** Mobile Animation */
		this.matchMedia.add("(max-width: 768px)", () => {

			let bg = this.querySelector(".filter-background");
			let ac = this.querySelector(".filter-actions");
			let dw = this.querySelector(".filter-drawer");

			this.timeline.fromTo([ac, dw], {
				translateX: "-100%"
			}, {
				translateX: 0,
				duration: 0.3,
				ease: "Power2.inOut"
			});

			this.timeline.fromTo(bg, {
				autoAlpha: 0,
				pointerEvents: "none"
			}, {
				autoAlpha: 1,
				pointerEvents: "all",
				duration: 0.3
			}, "-=0.3");
		});

		/** Pause at start */
		this.timeline.progress(0).pause();
	}

	/**
	 * activateFilter
	 * @param {object} event
	 */
	activateFilter(event) {

		event.preventDefault();

		const href = event.currentTarget.href;
		const url = href.indexOf("?") < 0 ? "" : href.slice(href.indexOf("?") + 1);

		console.log(url);

		this.getData(url, event);
	}

	/**
	 * bindEvents
	 */
	bindEvents() {

		/** --- history state --- */
		// TODO: Do I need this?
		this.addEventListener("history", this.onHistoryChange);

		/** --- form submit event --- */
		this.debounceSubmit = debounce((event) => {

			let btnEl = event.target.closest(".btn");

			if(btnEl) {

				(hasClass(btnEl, "active") ? btnEl.classList.remove("active") : btnEl.classList.add("active"));
			}

			this.onSubmit(event);

		}, 500);

		this.form.addEventListener("input", this.debounceSubmit.bind(this));

		/** --- Sorts --- */
		if(this.sort) {

			if(typeof this.sort == "object") {

				this.sort.forEach(radio => radio.addEventListener("change", this.debounceSubmit.bind(this)));

			} else {

				this.sort.addEventListener("change", this.debounceSubmit.bind(this));
			}
		}

		/** --- Sort Trigger --- */
		if(this.sortTrigger) this.sortTrigger.addEventListener("change", this.changeSort.bind(this));
	}

	/**
	 * changeSort
	 * @param {object} event
	 */
	changeSort(event) {

		let value = event.target.value;

		/** Multiple radios */
		if(typeof this.sort == "object") {

			this.sort.forEach((radio) => {

				if(radio.value == value) {

					radio.checked = "checked";
				}
			});
		}

		this.onSubmit(event);
	}

	/**
	 * getData
	 * @param {string} params		URL search params
	 * @param {object} event		Current triggering event
	 * @param {boolean} updateURL	Update history state
	 */
	getData(params, event, updateURL = true) {

		this.previousParams = params;

		this.grid.classList.add("loading");

		const url = `${window.location.pathname}?section_id=${this.gridId}${(params !== "") ? "&" + params : ""}`;

		this.loadData(url, event);

		/** --- Update url if needed --- */
		if(updateURL) this.updateHistory(params);
	}

	/**
	 * loadData
	 * @param {string} url
	 * @param {object} event
	 * @returns
	 */
	loadData(url, event) {

		/** --- Load from cache --- */
		if(this.filterCache[url]) {

			this.renderFilters(this.filterCache[url].html, event);
			this.renderGrid(this.filterCache[url].html);

			return;
		}

		fetch(url)
			.then((response) => {

				if(!response.ok){

					let error = new Error(response.status);

					throw error;
				}

				return response.text();
			})
			.then((text) => {

				const html = text;

				this.filterCache[url] = {
					html: html
				};

				this.renderFilters(html, event);
				this.renderGrid(html);
			})
			.catch((error) => {

				throw error;
			});
	}

	/**
	 * renderFilters
	 * @param {string} html
	 * @param {object} event
	 */
	renderFilters(html, event) {

		const dom = new DOMParser().parseFromString(html, "text/html");
		const filterDetailEls = dom.querySelectorAll("form .js-filter");

		const matchedFilters = (element) => {

			const jsFilter = event ? event.target.closest(".js-filter") : undefined;

			/** This strips the current section from rendering, keep active focus */
			if(jsFilter && element.dataset.index === jsFilter.dataset.index) {

				/** count actives */
				let clear = jsFilter.querySelector(".js-clear");
				let count = jsFilter.querySelectorAll("input:checked");
				let numbs = jsFilter.querySelectorAll("input[type='number']");
				let numbCount = (numbs.length > 0) ? Array.from(numbs).filter(input => !!input.value).length : 0;

				if(count.length > 0 || numbCount > 0) {
					clear.classList.remove("hidden");
				} else {
					clear.classList.add("hidden");
				}

				return true;
			}

			return false;
		}

		let filtersToRender;
		let isRemove = (event.target.closest("filter-remove")) || null;

		if(isRemove) {
			filtersToRender = filterDetailEls;
		} else {
			filtersToRender = Array.from(filterDetailEls).filter(element => !matchedFilters(element));
		}

		filtersToRender.forEach((element) => {
			document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`).innerHTML = element.innerHTML;
		});

		let totalCount = this.form.querySelectorAll("input[type='checkbox']:checked");

		this.renderActiveFilters(dom);
		this.filterToggle.resetCount(totalCount.length);
	}

	/**
	 * renderActiveFilters
	 * @param {string} html
	 * @returns
	 */
	renderActiveFilters(html) {

		const activeWrapper = html.querySelector(".active-filters");

		if(!activeWrapper) return;

		document.querySelector(".active-filters").innerHTML = activeWrapper.innerHTML;

		this.toggleActive(false);
	}

	/**
	 * renderAdditionalElements
	 * @param {string} html
	 * @returns
	 */
	renderAdditionalElements(html) {

	}

	/**
	 * renderGrid
	 * @param {string} html
	 */
	renderGrid(html) {

		const dom = new DOMParser().parseFromString(html, "text/html");

		this.grid.innerHTML = dom.querySelector(`[data-id="${this.gridId}"]`).innerHTML;

		window.Zero.lazyLoad.update();
	}

	/**
	 * updateHistory
	 * @param {string} params  URL search params
	 */
	updateHistory(params) {
		history.pushState({ params }, "", `${window.location.pathname}${(params === "") ? "" : "?".concat(params)}`);
	}

	/**
	 * toggleActive
	 */
	toggleActive(event) {

		// if(!event) return;

	}

	/**
	 * toggleOpen
	 */
	toggleOpen() {

		if(this.open === true || this.open === "true") {

			this.open = false;
			this.filterToggle.close();
			this.timeline.reverse();

			return;
		}

		this.open = true;
		this.filterToggle.open();
		this.timeline.play();
	}

	/**
	 * onSubmit
	 * @param {object} event
	 */
	onSubmit(event) {

		event.preventDefault();

		const formData = new FormData(this.form);
		const params = new URLSearchParams(formData).toString();

		this.getData(params, event);
	}

	/**
	 * onFilter
	 * @param {object} event
	 */
	onFilter(event) {

		event.preventDefault();

		this.toggleActive(event);

		const queryIndex = event.currentTarget.href.indexOf("?");
		const url = (queryIndex == -1) ? "" : event.currentTarget.href.slice(queryIndex + 1);

		this.getData(url, event);
	}

	/**
	 * onHistoryChange
	 */
	onHistoryChange(event) {

		const params = window.location.search.slice(1);

		if(params === this.previousParams) return;

		this.getData(params, null, false);
	}
}

/**
 * @typedef {Object} CustomElement~FilterRange
 */
// TODO: Maybe have this turn into a range pip slider?
class FilterRange extends HTMLElement {

	constructor() {

		super();

		this.inputs = this.querySelectorAll("input");
		this.inputs.forEach(element => element.addEventListener("change", this.onRangeChange.bind(this)));

		this.setMinMax();
	}

	onRangeChange(event) {

		this.adjustValidValues(event.currentTarget);
		this.setMinMax();
	}

	setMinMax() {

		let minInput = this.inputs[0];
		let maxInput = this.inputs[1];

		if(maxInput.value) minInput.setAttribute("max", maxInput.value);
		if(minInput.value) maxInput.setAttribute("min", minInput.value);

		if(minInput.value === "") maxInput.setAttribute("min", 0);
		if(maxInput.value === "") minInput.setAttribute("max", maxInput.getAttribute("max"));
	}

	adjustValidValues(input) {

		const value = Number(input.value);
		const min = Number(input.getAttribute("min"));
		const max = Number(input.getAttribute("max"));

		if(value < min) input.value = min;
		if(value > max) input.value = max;
	}
}

/**
 * @typedef {Object} CustomElement~FilterRemove
 */
class FilterRemove extends HTMLElement {

	constructor(){

		super();

		const btn = this.querySelector("a");
		const form = this.closest("filter-form") || document.querySelector("filter-form");

		btn.addEventListener("click", (event) => {

			event.preventDefault();

			form.activateFilter(event);
		});
	}
}

/**
 * @typedef {Object} CustomElement~FilterToggle
 */
class FilterToggle extends HTMLElement {

	constructor() {

		super();

		this.section = this.closest(".shopify-section");
		this.form = this.section.querySelector("filter-form");

		this.isOpen = this.dataset.open || false;
		this.btn = this.querySelector("button");
		this.btnText = this.btn.querySelector("span");
		this.btnCount = this.querySelector("small");

		this.addEventListener("click", this.toggle.bind(this));
	}

	open() {
		this.btnText.textContent = this.btnText.textContent.replace("Show", "Hide");
	}

	close() {
		this.btnText.textContent = this.btnText.textContent.replace("Hide", "Show");
	}

	resetCount(count) {

		if(count <= 0) {

			this.btnCount.textContent = "";

			return;
		}

		this.btnCount.textContent = `(${count})`;
	}

	toggle(event) {

		if(!this.form) return;

		this.form.toggleOpen();
	}
}

export {
	FilterForm,
	FilterRemove,
	FilterToggle
}
